import React from 'react';
import { Badge, Card, Row, Col, Button } from 'react-bootstrap';
import { FileText, Calendar2Date, Envelope, Person } from 'react-bootstrap-icons';
import moment from 'moment';

const ReportCard = ({ report, onViewPdf }) => {
  return (
    <Card className="mb-1" style={{ opacity: report.superseded ? 0.50 : 1 }}>
      <Card.Body>
        <Row>
          <Col xs={9}>
            <div className="d-flex align-items-center">
              <div
                className="bg-light p-2 rounded mr-3 d-flex align-items-center justify-content-center border"
                style={{ width: '48px', height: '48px' }}
              >
                <FileText size={24} className="text-dark" />
              </div>
              <div className="d-flex flex-column">
                <div className="d-flex align-items-center text-muted small mb-1">
                  <Person size={16} className="mr-1" />
                  <span>Shared by {report.createdBy?.name}</span>
                  {report.isPreliminary && (
                    <Badge variant="info" className="ml-2">
                      Preliminary
                    </Badge>
                  )}
                </div>
                <div className="d-flex align-items-center text-muted small mb-2">
                  <Calendar2Date size={14} className="mr-1" />
                  <span>{moment(report.createdAt).format('MMM D, YYYY')}</span>
                  <span className="mx-1">•</span>
                  <span>{moment(report.createdAt).format('h:mm A')}</span>
                  {report.superseded && (
                    <Badge variant="secondary" className="ml-2">
                      Superseded
                    </Badge>
                  )}
                </div>

                <div className="d-flex align-items-center">
                  <div className="d-flex align-items-center">
                    {report.recepients.map((email, idx) => (
                      <Badge key={idx} variant="dark" className="mr-1">
                        <Envelope size={14} className="mr-1" />
                        {email}
                      </Badge>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={3} className="d-flex justify-content-end align-items-center">
            <Button variant="outline-dark" size="sm" onClick={() => onViewPdf(report?.file)}>
              View PDF
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ReportCard;
